// extracted by mini-css-extract-plugin
export default {"title":"CustomCharacterSelect_title__WUSyT","listGroup":"CustomCharacterSelect_listGroup__BryXn"};